
import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, State, Mutation } from "vuex-class";

import { BModal } from "bootstrap-vue";
import {
	axiosJsonInstance
} from "@/axios.instance";
import { ILatLng } from "@sureview/v2-mapping";

import {
	Guard,
	GuardTour,
	DispatchableEvent,
	MapOptions,
	DispatchStatus,
	GuardsByStatus,
	EventStatus,
	DispatchQueue,

	GuardDispatchQueue,
	DispatchApi
} from "@sureview/v2-dispatch"

import { UserPermissions } from "@/store/types";

const dispatchApi = new DispatchApi(axiosJsonInstance);

interface ExtendOption {
	label: string,
	minutes: number
}

@Component({
	components: {
	}
})
export default class ExtendTimer extends Vue {
	$refs: {
		timerModal: BModal
	};

	@Getter getPermissions: UserPermissions;

	public guard: Guard = null;
	public statusLabel: string = "";
	public timerLabel: string = "";

	private extendByOptions: ExtendOption[] = [
		{ label: "5 minutes", minutes: 5 },
		{ label: "10 minutes", minutes: 10 },
		{ label: "15 minutes", minutes: 15 },
		{ label: "30 minutes", minutes: 30 },
	];

	private get userCanExtendTimers(): boolean {
		return this.getPermissions.canExtendAlerts;
	}

	private get started() {
		return this.guard ? "Started " + this.guard.trackingMoment.fromNow() : "";
	}

	public get isOpen() {
		return !!this.guard;
	}
	public set isOpen(value: boolean) {
		if (!value) {
			this.guard = null;
		}
	}

	public open (guard: Guard, statusLabel: string, timerLabel: string) {
		this.statusLabel = statusLabel;
		this.timerLabel = timerLabel;
		this.guard = guard;
	}

	public async extendTimer(minutes: number) {
		await dispatchApi.extendTimer(this.guard.guardId, minutes);
		this.guard = null;
	}
}

